import { render, staticRenderFns } from "./ClippingRequests.vue?vue&type=template&id=cea8b392"
import script from "./ClippingRequests.vue?vue&type=script&lang=js"
export * from "./ClippingRequests.vue?vue&type=script&lang=js"
import style0 from "./ClippingRequests.vue?vue&type=style&index=0&id=cea8b392&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports